export const urlMap = {
        "nominate": 'https://web-production-58ed.up.railway.app/api/get/playerNominateByEdition',
        "eleven":'https://web-production-58ed.up.railway.app/api/get/goldenBallEdition',
        'winner':''
    }

export const urlVoteMap = {
        "nominate": 'https://web-production-58ed.up.railway.app/api/vote/byPlayer',
        "eleven":'https://web-production-58ed.up.railway.app/api/vote/byPlayerXI',
        'winner':'https://web-production-58ed.up.railway.app/api/vote/byGoldenBall'

}

export const urlVoteSevenMap = {
        "nominate": 'https://web-production-58ed.up.railway.app/api/vote/byPlayerSeven',
}